<template>
  <div class="case">
    <div class="left">
      <p
        v-for="(item, index) in type"
        :key="index"
        :class="{ active: active == index }"
        @click="check(index)"
      >
        {{ item.title }}
      </p>
    </div>
    <div class="swiper pc">
      <router-link
        tag="div"
        :to="{
          path: '/case-list',
          query: { api: 'cases_details', id: type[active].id },
        }"
        class="box"
        :style="{
          backgroundImage: 'url(' + type[active].img + ')',
        }"
      >
        <img src="../assets/mask.png" alt="" />
        <div>
          <p class="title">{{ type[active].title }}</p>
          <p class="desc">{{ type[active].en_title }}</p>
          <p class="more">MORE <i class="el-icon-arrow-right"></i></p>
        </div>
      </router-link>
    </div>
    <div class="mobile">
      <router-link
        tag="div"
        :to="{
          path: '/case-list',
          query: { api: 'cases_details', id: type[active].id },
        }"
        :key="index"
        class="box"
        :style="{
          backgroundImage: 'url(' + type[active].img + ')',
        }"
      >
        <img src="../assets/mask.png" alt="" />
        <div>
          <p class="title">{{ type[active].title }}</p>
          <p class="desc">{{ type[active].en_title }}</p>
          <p class="more">MORE <i class="el-icon-arrow-right"></i></p>
        </div>
      </router-link>
    </div>
  </div>
</template>

<script>
import { case_cate, cases } from '../utils/api'
export default {
  data() {
    return {
      options: {
        slidesPerView: 2.2,
        mousewheel: {
          releaseOnEdges: true,
        },
      },
      type: [],
      list: [],
      active: 0,
    }
  },
  created() {
    case_cate((r) => {
      this.type = r.data
    })
  },
  methods: {
    check(e) {
      this.active = e
    },
  },
}
</script>

<style lang="less" scoped>
.swiper {
  width: calc(100vw - 734px);
}
.case {
  display: flex;
  .left {
    width: 734px;
    height: 100vh;
    background: url('../assets/sampleRoom_bg.png') no-repeat;
    background-size: cover;
    display: flex;
    flex-direction: column;
    justify-content: center;
    p {
      width: 50%;
      padding-left: 120px;
      box-sizing: border-box;
      font-size: 30px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      line-height: 40px;
      color: #909090;
      transition: all 0.15s linear;
      position: relative;
      margin-bottom: 60px;
      cursor: pointer;
      transform: translateY(-40px);
    }
    p::after {
      width: 0%;
      content: '';
      position: absolute;
      bottom: -20px;
      left: 0;
      transition: all 0.15s linear;
      border-bottom: 1px solid #006C8F;
    }
    p.active {
      color: #006C8F;
    }
    p.active::after {
      width: 100%;
    }
  }

  // .box:hover {
  //   img {
  //     opacity: 0;
  //   }
  //   & > div {
  //     background: rgba(255, 255, 255, 0.8);
  //     .more {
  //       margin-top: 40px;
  //       font-size: 18px;
  //     }
  //   }
  // }
  .box {
    cursor: pointer;
    background-size: cover;
    background-repeat: no-repeat;
    height: 870px;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    position: relative;
    img {
      width: 100%;
      height: 100%;
      position: absolute;
      top: 0;
      left: 0;
      opacity: 0;
      transition: all 0.15s linear;
    }
    & > div {
      width: 340px;
      height: 182px;
      background: rgba(255, 255, 255, 0);
      justify-content: center;
      align-items: center;
      flex-direction: column;
      display: flex;
      transition: all 0.15s linear;
      padding: 17px;
      box-sizing: border-box;
      background: rgba(26, 26, 26, 0.8);
      .title {
        font-size: 34px;
        font-family: Source Han Sans CN;
        font-weight: 400;
        color: white;
        overflow: hidden;
        white-space: nowrap;
        width: 100%;
        text-overflow: ellipsis;
        text-align: center;

      }
      .desc {
        font-size: 18px;
        font-family: Arial;
        font-weight: 400;
        line-height: 21px;
        color: #c8c8c8;
        margin-top: 10px;
        text-align: center;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        width: 100%;
      }
      .more {
        margin-top: 16px;
        font-size: 18px;
        font-family: Source Han Sans CN;
        font-weight: 400;
        line-height: 31px;
        color: white;
        transition: all 0.15s linear;
        transform: translateY(-3px);
      }
    }
  }
}
@media (max-width: 767px) {
  .case {
    margin-top: 0.88rem;
    flex-wrap: wrap;
    .left {
      width: 100%;
      height: unset;
      padding-top: 1.9rem;
      padding-bottom: 1.33rem;
      p {
        padding-left: 0.68rem;
        font-size: 0.4rem;
      }
      
    }
    .box {
      width: 100vw;
      height: 5.5rem;
      img {
      }
      & > div {
        position: relative;
        z-index: 1;
        width: calc(100% - 2.4rem);
        padding: 0.34rem;
        box-sizing: border-box;
        .title {
          font-size: 0.4rem;
          line-height: unset;
          color: white;
        }
        .desc {
          font-size: 0.24rem;
          margin-top: 0.12rem;
        }
        .more {
          margin-top: 0.68rem;
          font-size: 0.24rem;
        }
      }
    }
  }
}
</style>